import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useUnsafeTranslation } from '../../i18next';
import { useRoutes } from '../../routes';

const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;

  > p {
    max-width: 60ch;
    text-align: center;
    margin-bottom: ${(p) => p.theme.spacing(4)}px;
  }
`;

export const NoAccess = ({
  buttonLabel,
  buttonLink,
  action,
  title
}: {
  buttonLabel?: string;
  buttonLink?: string;
  action?: string;
  title?: string;
}) => {
  const { t } = useUnsafeTranslation();
  const { ROUTES } = useRoutes();

  return (
    <Container>
      <Typography component="h1" variant="h1" gutterBottom={true}>
        {title || t('You can’t access this page')}
      </Typography>

      <Typography>
        {t(
          'Your account’s permissions prevent you from {{action}}. If you think this is a mistake, contact an account administrator in your organization.',
          {
            action: action || t('accessing this page')
          }
        )}
      </Typography>

      <Link to={buttonLink || ROUTES.home.overview.url()}>
        <Button color="primary" variant="contained">
          {buttonLabel || t('Go to Home')}
        </Button>
      </Link>
    </Container>
  );
};

export const NoAccessAtSubscriptionLevel = ({
  buttonLabel,
  buttonLink
}: {
  buttonLabel?: string;
  buttonLink?: string;
  action?: string;
  title?: string;
}) => {
  const { t } = useUnsafeTranslation();
  const { ROUTES } = useRoutes();

  return (
    <Container>
      <Typography component="h1" variant="h1" gutterBottom={true}>
        {t('You can’t access this page')}
      </Typography>

      <Typography>
        {t(
          'This feature isn’t available at your current subscription level. Upgrade to get access.'
        )}
      </Typography>

      <Link to={buttonLink || ROUTES.home.overview.url()}>
        <Button color="primary" variant="contained">
          {buttonLabel || t('Go to Home')}
        </Button>
      </Link>
    </Container>
  );
};
